import React from 'react';
import { TableOfContentsStaticStack } from './TableOfContentsStatic.styles';
import { TableOfContentsStackContent } from './TableOfContents.styles';
import Typography from 'atoms/Typography/Typography';
import { TableOfContent } from 'src/functions/getTableOfContentDictionary';
import TableOfContentsSocialLinks from './TableOfContentsSocialLinks';
import TableOfContentsLinks from './TableOfContentsLinks';

interface TableOfContentsStaticProps {
  title?: string;
  slug: string;
  articleTitle: string;
  pathPrefix: string;
  tableOfContents: TableOfContent[];
}

const TableOfContentsStatic = ({
  title,
  slug,
  articleTitle,
  pathPrefix,
  tableOfContents,
}: TableOfContentsStaticProps): JSX.Element => {
  return (
    <TableOfContentsStaticStack
      direction='column'
      maxWidth='width-xl'
    >
      <TableOfContentsStackContent
        padding={['spacing-4xl', 'spacing-none']}
        direction='column'
        gap='spacing-xl'
      >
        <Typography
          size='md'
          type='paragraph'
          color='text-brand-tertiary'
          fontWeight='font-weight-semibold'
        >
          {title}
        </Typography>
        <TableOfContentsLinks tableOfContents={tableOfContents} />
      </TableOfContentsStackContent>
      <TableOfContentsSocialLinks
        pathPrefix={pathPrefix}
        slug={slug}
        articleTitle={articleTitle}
      />
    </TableOfContentsStaticStack>
  );
};

export default TableOfContentsStatic;
